export default __webpack_public_path__ + "static/media/peppa.07e1f3ef.png";